<template>
  <div id="app" :class="{ bg }">
    <pageHeader ref="pageHeader" v-if="!$route.meta.isShow" />
    <div class="user-bg" v-if="isUser">
      <img class="bg-icon" src="@/assets/img/user-bg@2x.png" alt="" />
      <div class="user-bg-info">
        <div class="name">
          <p class="text">个人中心</p>
          <a
            class="exit"
            @click="$refs.pageHeader.logOut()"
            href="javascript:;"
          >
            <span>退出登录</span>
          </a>
        </div>
        <p class="tips">欢迎来到个人中心！</p>
      </div>
    </div>
    <div class="center-bg" v-if="isCenter">
      <img class="bg-icon" src="@/assets/img/kaoshizhongxin@2x.png" alt="" />
      <div class="user-bg-info">
        <div class="name">
          <p class="text">考试中心</p>
        </div>
        <p class="tips">试卷列表、考试结果</p>
      </div>
    </div>
    <div class="page-wrap" v-if="!$route.meta.isShow && !$route.meta.area">
      <router-view />
    </div>
    <div class="page" v-else>
      <router-view />
    </div>
    <footer v-if="!$route.meta.isShow">
      <div class="footer">
        <div class="info">
          <a href="">
            <!-- <img src="@/assets/img/LOGO@2x-1.png" class="logo" alt="" /> -->
          </a>
          <p class="company">{{ companyInfo.enter_prise_name }}</p>
          <a href="http://beian.miit.gov.cn/" target="_blank" class="number"
            >粤ICP备20046369号</a
          >
        </div>
        <div class="contact">
          <div class="text">联系邮箱</div>
          <div class="num">check@wanfangtech.com</div>
        </div>
        <!-- <div class="about">
          <div class="text">关于我们</div>
          <p>
            广东万方数据信息科技有限公司，成立于2020年。是北京万方数据股份有限公司旗下唯一独立运营的互联网高科技公司。
          </p>
        </div> -->
        <div class="eail">
          <div class="art">
            <router-link to="/newsInfo?articleId=2" class="item"
              >服务协议</router-link
            >
            <router-link to="/newsInfo?articleId=3" class="item"
              >隐私协议</router-link
            >
          </div>
        </div>
        <!-- <div class="customer">
          <div class="download">
            <a href="">App Store 下载</a>
            <a href="">Android 下载</a>
          </div>
          <div class="service">
            <p>官方客服：</p>
            <img src="@/assets/image/code.png" class="item" alt="" />
            <img src="@/assets/image/code.png" alt="" />
          </div>
        </div> -->
      </div>
    </footer>
  </div>
</template>

<script>
import pageHeader from "@/components/pageHeader";
import router from "./router";
import { getLogoByDomain } from "@/api/login";
import { getFullDomain } from "@/utils/common";
export default {
  components: {
    pageHeader,
  },
  data() {
    return {
      bg: false,
      isUser: false,
      isCenter: false,
      companyInfo: {},
    };
  },
  created() {
    getLogoByDomain({ domain_name: getFullDomain(location) }).then((result) => {
      this.companyInfo = result.data.result;
      this.setFavicon(this.companyInfo.icon); // 替换为新的 favicon 文件 URL
    });

    router.afterEach((to, from) => {
      this.isUser = to.matched[0].path === "/my";
      this.isCenter = to.matched[0].path === "/examination/center";
      if (
        to.path === "/examination/imitate" ||
        to.path === "/examination/contrast" ||
        to.path === "/examination/center" ||
        to.path === "/" ||
        to.path === "/my/information" ||
        to.path === "/my/collectJobs" ||
        to.path === "/my/requiredCourse" ||
        to.path === "/my/about" ||
        to.path === "/jobInfo" ||
        to.path === "/examination/index" ||
        to.path === "/examination/imitateTion" ||
        to.path === "/myCourse"
      ) {
        this.bg = true;
      } else {
        this.bg = false;
      }
    });
  },
  mounted() {},
  methods: {
    setFavicon(newIconUrl) {
      // 创建新的 link 标签
      document.title =
        this.companyInfo.short_name || this.companyInfo.enter_prise_name;
      var newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.type = "image/x-icon";
      newLink.href = newIconUrl;

      // 获取并移除原有的 favicon link（如果有多个，可能需要更精确的选择器）
      var oldLinks = document.querySelectorAll('link[rel="icon"]');
      for (var i = 0; i < oldLinks.length; i++) {
        oldLinks[i].parentNode.removeChild(oldLinks[i]);
      }

      // 将新创建的 link 插入到 head 中
      document.head.appendChild(newLink);
    },
  },
};
</script>

<style lang="less">
@import "./assets/css/reset.less";
.scroll-container::-webkit-scrollbar {
  display: none; /* 对于Chrome, Safari和Opera */
}

html,
body {
  height: 100%;
  margin: 0;
  // background-color: #f8f8fa;
  background: #f6f7fa;
  min-width: 1210px;
  color: #030303;
}

#app {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ffff;

  &.bg {
    background-color: #f7f8fc;
  }
}

/*设置宽度,轨道颜色*/
::-webkit-scrollbar {
  width: 5px;
  height: 10px;
  background: #e6e6e6;
  /*可以设置轨道颜色*/
  padding-right: 2px;
}

/*滚动条*/
::-webkit-scrollbar-thumb {
  // background: #0675f8;
  border-radius: 10px;
}

.line-clamp-1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.line-clamp-2 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.line-clamp-3 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

.noData {
  padding-top: 75px;
  color: #5e6272;
  text-align: center;

  .emptyimg {
    width: 175px;
  }

  .empty-text {
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    margin-top: 2px;
  }
}

.center-bg {
  width: 100%;
  position: relative;
  padding-top: 52px;
  background: #1572f8;
  margin-top: 60px;
  .bg-icon {
    display: block;
    width: 100%;
    width: 1210px;
    height: 260px;
    // object-fit: cover;
    margin: auto;
  }
  .user-bg-info {
    width: 1210px;
    position: absolute;
    left: 245px;
    right: 0;
    margin: auto;
    top: 158px;
    .name {
      display: flex;
      align-items: center;
      .text {
        font-family: AlibabaPuHuiTiH;
        font-size: 28px;
        color: #ffffff;
        font-style: normal;
        font-weight: 600;
      }
      .exit {
        margin-left: auto;
        width: 135px;
        height: 44px;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 16px;
          margin-right: 8px;
        }
      }
    }
    .tips {
      font-family: AlibabaPuHuiTiR;
      font-size: 16px;
      color: #ffffff;
      line-height: 22px;
      margin-top: 6px;
    }
  }
}
.user-bg {
  width: 100%;
  position: relative;
  padding-top: 52px;
  .bg-icon {
    display: block;
    width: 100%;
    height: 200px;
    object-fit: cover;
  }
  .user-bg-info {
    width: 1210px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 140px;
    .name {
      display: flex;
      align-items: center;
      .text {
        font-family: AlibabaPuHuiTiH;
        font-size: 28px;
        color: #ffffff;
        font-style: normal;
        font-weight: 600;
      }
      .exit {
        margin-left: auto;
        width: 112px;
        height: 44px;
        background: #ffffff;
        border-radius: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 16px;
        color: #0b1d28;
        img {
          width: 16px;
          margin-right: 8px;
        }
      }
    }
    .tips {
      font-family: AlibabaPuHuiTiR;
      font-size: 16px;
      color: #ffffff;
      line-height: 22px;
      margin-top: 6px;
    }
  }
}

.page-wrap {
  width: 1210px;
  margin: 0 auto;
  padding-bottom: 30px;
  min-height: calc(100vh - 180px);
  box-sizing: border-box;
}
.page {
  min-height: calc(100vh - 180px);
}

footer {
  height: 180px;
  background: #56595f;
  box-sizing: border-box;
  padding-top: 30px;
  z-index: 999;

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1210px;
    margin: auto;
    color: #fff;
    .contact {
      flex: 1;
      margin-left: 100px;
      margin-top: 10px;
      .text {
        font-size: 14px;
        font-weight: 600;
        color: #ffffff;
      }
      .num {
        margin-top: 10px;
      }
    }

    .info {
      .logo {
        width: 56px;
        height: 34px;
      }

      .number {
        margin-top: 13px;
        font-size: 12px;
        font-weight: 400;
        color: #ececec;
        display: block;
      }

      .company {
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
        margin-top: 13px;
      }
    }

    .about {
      flex: 1;
      margin: 0 57px;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;

      .text {
        font-size: 14px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 27px;
      }
    }

    .eail {
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      margin-left: 100px;

      .text {
        font-size: 14px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 27px;
      }
      .art {
        display: flex;
        margin-top: 14px;
        .item {
          font-size: 14px;
          color: #ffffff;
          margin-right: 10px;
        }
      }
    }

    // .customer {
    //   margin-left: auto;

    //   .download {
    //     display: flex;

    //     a {
    //       height: 30px;
    //       background: #000000;
    //       border-radius: 4px;
    //       border: 1px solid #9d9d9d;
    //       padding: 0 10px 0 32px;
    //       display: flex;
    //       align-items: center;
    //       color: #ffffff;
    //       font-size: 12px;
    //       font-weight: 600;
    //       margin-left: 10px;
    //       background-repeat: no-repeat;
    //       background-size: 20px;
    //       background-position: left 5px center;
    //       background-image: url("@/assets/image/apple-icon@2x.png");

    //       &:first-child {
    //         margin-left: 0;
    //         background-image: url("@/assets/image/Android-icon@2x.png");
    //       }
    //     }
    //   }

    //   .service {
    //     display: flex;
    //     justify-content: flex-end;
    //     font-weight: 600;
    //     color: #ffffff;
    //     font-size: 14px;
    //     line-height: 22px;
    //     margin-top: 30px;

    //     img {
    //       width: 70px;
    //       margin-left: 10px;

    //       &.item {
    //         margin-left: 33px;
    //       }
    //     }
    //   }
    // }
  }
}

.el-button--primary {
  background: #0675f8 !important;
  border-color: #0675f8 !important;
}
/* 隐藏整个页面或某个元素的滚动条 */
.no-scrollbar {
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE 和 Edge */
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, and Opera */
}
</style>
